/** Tipi del contratto API. In un file a parte perche' il file generato li usa
 *  e `routes.ts` usa il file generato: metterli insieme farebbe un ciclo. */
export var Access;
(function (Access) {
    /** Non esposto. Lo chiamano i worker, non la UI. Esporlo sarebbe un errore:
     *  `sensor.pushReading` inietterebbe letture di gas false, `ptz.onAlarmRaised`
     *  simulerebbe un allarme. */
    Access["Internal"] = "internal";
    /** Nessuna sessione richiesta. Solo cio' che serve PRIMA di averne una:
     *  login, me, logout, bootstrapStatus, bootstrapAdmin. */
    Access["Public"] = "public";
    /** Sessione richiesta; il permesso specifico lo verifica l'handler.
     *
     *  Il permesso NON viene ripetuto qui di proposito: in piu' casi non e' un
     *  valore fisso — `clusters.update` autorizza per campo, `settings.update`
     *  per chiave. Duplicarlo darebbe due fonti di verita' che divergono al
     *  primo campo nuovo, e la piu' permissiva vincerebbe in silenzio. */
    Access["Authenticated"] = "authenticated";
    /** Sessione E permesso, verificati dal dispatcher perche' l'handler non lo
     *  fa. Chiude i buchi ereditati dall'app desktop. */
    Access["RequirePermission"] = "requirePermission";
})(Access || (Access = {}));
//# sourceMappingURL=types.js.map